module.exports = __webpack_public_path__ + "img/16.3-gallery.a0ddccd4.jpg";